import { ProfileRow, ProfileSection, ProfileSections } from '../../components/ProfileSection';

const EMPTY = '----';

interface Props {
    salary: string | undefined;
    data: any | null;
    visaStatus: string | undefined;
};

export default function PersonalInformation({ data }: Props) {
    return (
        <ProfileSections>
            <ProfileSection title='Personal information'>
                <ProfileRow label='Full name'>{data?.firstName} {data?.lastName}</ProfileRow>
                <ProfileRow label='Phone number'>{data?.phoneNumber}</ProfileRow>
                <ProfileRow label='Preferred name'>{data?.preferrdName || EMPTY}</ProfileRow>
                <ProfileRow label='Email'>{data?.email}</ProfileRow>
                <ProfileRow label='DOB'>{data?.birthdate}</ProfileRow>
                <ProfileRow label='City'>{data?.city || EMPTY}</ProfileRow>
                <ProfileRow label='Country'>{data?.country || EMPTY}</ProfileRow>
                <ProfileRow label='Zip code'>{data?.zipCode || EMPTY}</ProfileRow>
                <ProfileRow label='State'>{data?.state || EMPTY}</ProfileRow>
                <ProfileRow label='LinkdIn link'>{data?.linkedinLink || EMPTY}</ProfileRow>
            </ProfileSection>

            <ProfileSection title='Salary & visa'>
                <ProfileRow label='Salary expectation'>
                    {data?.desiredAnnualSalaryRange ? `${data.desiredAnnualSalaryRange}$` : EMPTY}
                </ProfileRow>
                <ProfileRow label='e.g. H-1B visa status requirement'>
                    {data?.requireSponsorshipVisa}
                </ProfileRow>
            </ProfileSection>
        </ProfileSections>
    );
};
